import { Suspense } from 'react'

import ErrorBoundary from '@cox/core-ui8/dist/ErrorBoundary'
import Fallback from '@cox/core-ui8/dist/Fallback'
import PageLoader from '@cox/core-ui8/dist/PageLoader'

import IsInEditorText from '../../components/shared/IsInEditorText'
import { getSpacing } from '../../utils/spacing-util'

export type AEMProps = {
  isInEditor?: boolean
  top?: boolean
  left?: boolean
  right?: boolean
  bottom?: boolean
  lob?: string
  compName?: string
  className?: string
  atomSpacing?: boolean
  rest?: any
  showErrorBanner?: boolean
  componentTypeRenderer?: any
}

const withAEM = (Component: any, customProps?: AEMProps) => {
  const WrappedComponent = (props: any) => {
    const { isInEditor = false, top = false, left = false, right = false, bottom = false, lob = '', ...rest } = props

    const compName = props?.compName || customProps?.compName
    const atomSpacing = props?.atomSpacing || customProps?.atomSpacing
    const showErrorBanner = props?.showErrorBanner || customProps?.showErrorBanner

    const getChildren = () => {
      if (showErrorBanner) {
        return (
          <Suspense fallback={<PageLoader />}>
            <ErrorBoundary fallback={<Fallback isBanner={true} />}>
              <Component
                className={`${getSpacing(top, right, bottom, left, atomSpacing)} ${lob}`}
                isInEditor={isInEditor}
                {...customProps}
                {...rest}
              />
            </ErrorBoundary>
          </Suspense>
        )
      }
      return (
        <Component
          className={`${getSpacing(top, right, bottom, left, atomSpacing)} ${lob}`}
          isInEditor={isInEditor}
          {...customProps}
          {...rest}
        />
      )
    }
    return (
      <>
        {IsInEditorText(isInEditor, compName)}
        {getChildren()}
      </>
    )
  }
  return WrappedComponent
}

export default withAEM
